import { campaignRecipientSchema } from "@redotech/redo-model/campaigns/campaign-recipient-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getCampaignRecipientsByOrderId = {
  name: "getCampaignRecipientsByOrderId" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({ campaignRecipients: z.array(campaignRecipientSchema) }),
};
